import React from "react";
import { CardStyled as HeadCard } from "../../custom/cards/card.styled";
import { CardText, CardTitle, CardBody } from "./report-cards.styled";
import { Image, Space } from "@nubeteck/components";

interface IInfoCardProps {
  title: string;
  info: string;
  icon: string;
}

const InfoCard = ({ title, info, icon }: IInfoCardProps) => (
  <HeadCard
    style={{ display: "flex", alignItems: "center", height: "90px" }}
    bodyStyle={{ padding: "5px 15px 5px 10px", width: "100%" }}
  >
    <CardBody>
      <Image preview={false} src={icon} width={32} />
      <Space direction="vertical" style={{ textAlign: "end", marginLeft: 32 }}>
        <CardTitle>{title}</CardTitle>
        <CardText>{info}</CardText>
      </Space>
    </CardBody>
  </HeadCard>
);

export default InfoCard;
